export enum ADDRESS_TYPES_ENUM {
  location = 'location',
  home = 'home',
  billing = 'billing',
}
